import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import templateService from '../../../services/templateService'
import { Template } from '@leadgen/models/client'

class TemplateActions {
  loadTemplate = createAsyncThunk(
    'template/loadTemplate',
    async ({ companyId }: { companyId: string }, { dispatch }) => {
      const response = await templateService.subscribeToTemplate({
        companyId,
        onTemplateUpdated: template => {
          dispatch(this.updateTemplate(template))
        },
        onTemplateAdded: template => {
          dispatch(this.setTemplateAfterCreate(template))
        },
      })
      return response
    },
  )
  updateTemplate = createAction('template/updateTemplate', (template: Template) => ({
    payload: template,
  }))
  setTemplateAfterCreate = createAction(
    'template/setTemplateAfterCreate',
    (template: Template) => ({
      payload: template,
    }),
  )
  updateTemplateAfterSave = createAction('template/updateTemplateAfterSave', (version: number) => ({
    payload: version,
  }))
}

export default new TemplateActions()
